export const isHealthCheck = window.location.search.includes('healthCheck=true');